export enum Platform {
  SAAS = 'saas',
  ADMIN = 'admin',
}
